<template>
  <div class="videoSlider" v-if="slides">
    <div class="slider">
      <button class="leftArrow" @click="prev"><img src="../assets/btn_arrow_left_dark.jpg"/></button> 
      <div class="logoVidFlex">
        <img class="videoLogo" v-if="slides[currentNumber].logo" :src="slides[currentNumber].logo">
        <img v-if="slides[currentNumber].videoUrl" class="videoslides" @click="openModal()" :src="slides[currentNumber].videoUrl"/>
        <div v-if="slides[currentNumber].imgUrl" class="imgslides">
          <img :src="slides[currentNumber].imgUrl"/>
        </div>
        <p class="text-block" v-if="slides[currentNumber].text" v-html="slides[currentNumber].text"></p>
      </div>
      <button class="rightArrow" @click="next"><img src="../assets/btn_arrow_right_dark.jpg"/></button>
    </div>
    <div>
      <h2 id="videoslideTitle">{{slides[currentNumber].header}}</h2>
    </div>

    <!-- The Modal/Lightbox -->
    <div v-if="showModal" id="myModal" class="modal">
      <span class="close cursor" @click="closeModal()">&times;</span>
      <div class="modal-content">
        <div class="mySlides">
          <iframe class="video" width="640" height="360" :src="slides[currentNumber].popupUrl" frameborder="0" allowfullscreen></iframe>
          <p v-if="currentNumber === 2" class="lightBoxText"><a href="https://vimeo.com/270608052">Making Authentic Friendships on iFundWomen</a> from <a href="https://vimeo.com/ifundwomen">iFundWomen</a> on <a href="https://vimeo.com">Vimeo</a>.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "videoSlider",
  data:function() {
    return {
      slides: [
        {
          header: 'ForbesWomen - Editor\'s Pick',
          imgUrl: require('../assets/JulianaHeadshot.jpg'),
          text: 'Forbes wrote an article discussing how Juliana\'s work through MAF has helped the disabled community. <a href="https://www.forbes.com/sites/pauleannareid/2020/04/06/how-this-college-student-built-and-funded-a-revolutionary-app-for-the-autistic-and-disabled-community/#7f92b4e23d40" target="_blank">Read what they wrote here</a>!',
        },
        {
          header: 'Maiden Creative Presents MAF',
          logo: require('../assets/Lifetime_logo_2020.svg'),
          videoUrl: require('../assets/HerTake.png'),
          text: 'Watch the video <a href="https://vimeo.com/399489483/c80cc600fa" target="_blank">here</a>!',
          slideIdx: 0,
        },
        {
          header: 'Juliana discusses MAF on Cheddar',
          logo: require('../assets/vidlogo_Cheddar.jpg'),
          videoUrl: require('../assets/vid_Cheddar.jpg'),
          popupUrl: 'https://cheddar.com/media/this-app-is-helping-people-with-autism-make-friends/player?autoplay=false',
          slideIdx: 1,
        },
        {
          header: 'ABC Story Covers MAF',
          imgUrl: require('../assets/ABC7Logo.png'),
          slideIdx: 2,
          text: 'Juliana was interviewed by ABC news concerning the story behind Making Authentic Friendships. The video was viewed over 360,000 times!<br/><a target="_blank" href="https://abc7ny.com/5891843/?ex_cid=TA_WABC_TW&taid=5e3b00690f91f60001a2725c&utm_campaign=trueAnthem%3A+New+Content+%28Feed%29&utm_medium=trueAnthem&utm_source=twitter&fbclid=IwAR3tfDZSlMbh__3MXArzixjEmAhCPjj2Z8pI7pCOc9WH85uC0zCtYZD8tF8">Watch the interview here!</a>'
        },
        {
          header: 'Making Authentic Friendships on iFundWomen',
          logo: require('../assets/vidlogo_iFund.jpg'),
          videoUrl: require('../assets/vid_iFund.jpg'),
          popupUrl: 'https://player.vimeo.com/video/270608052',
          slideIdx: 3,
        },
        {
          header: 'Go Live Girl',
          logo: require('../assets/GoLiveGirl.jpg'),
          text: 'Juliana has been a panelist for Go Live Girl "Girl Boss", aiming to encourage middle and high school girls to follow their dreams and create businesses that make a positive social/environmental impact.'
        },
        {
          header: 'Bloomberg HQ',
          logo: require('../assets/bloomberglogo.png'),
          text: 'Juliana was a panelist for Bloomberg HQ in NYC. This was a crowdfunding panel where she spoke about her experience with crowdfunding through ifundwomen. She was the youngest and only female panelist.'
        },
        {
          header: '#InThisTogether',
          imgUrl: require('../assets/NowThis.png'),
          text: 'Now This has covered how MAF is already improving lives. Watch it <a href="https://www.facebook.com/watch/?v=672312930336507" target="_blank">here</a>.'
        },
        {
          header: 'Autism Speaks',
          imgUrl: require('../assets/MAFAutismSpeaks.jpeg'),
          text: 'Juliana wrote a piece with Autism Speaks to promote Making Authentic Friendships as well as the need for everyone to be able to make meaningful relationships.<br/><a target="_blank" href="https://www.autismspeaks.org/blog/autism-apps-making-friends">Read her article here!</a>'
        },
        {
          header: 'Newsday Lifestyle / Family',
          imgUrl: require('../assets/MAFLifestyle.jpg'),
          text: 'Newsday wrote a Lifestyle / Family piece about Juliana and her MAF application in November, 2019.<br/><a target="_blank" href="https://www.newsday.com/lifestyle/family/making-authentic-friendships-fetherman-autism-1.38004341">Read what they wrote here!</a>'
        },
        {
          header: 'Patch',
          imgUrl: require('../assets/MAFPatch.jpg'),
          text: 'Patch wrote an article about Juliana, going in-depth into the app and how it can help users with challenges making friends on their own.<br/><a target="_blank" href="https://patch.com/new-york/kingspark/li-woman-making-app-help-those-w-special-needs-find-friends">Read what they wrote here!</a>'
        },
        {
          header: 'News 12 Features MAF',
          imgUrl: require('../assets/News12.png'),
          text:'Juliana appeared on <a target="_blank" href="http://longisland.news12.com/story/41682115/kings-park-woman-creates-app-to-help-people-with-special-needs-make-friends?fbclid=IwAR1MX8mmOAgXlyUzzI7HkVx1sOyhtV5JP7XzMxpfLwloWVeFTmzEraLSFVc"> News 12 </a>to talk about the process of making and running Making Authentic Friendships.',
        },
        {
          header: 'Fox 5 Interview with Juliana',
          imgUrl: require('../assets/Fox5.jpg'),
          text:'Juliana appeared on <a target="_blank" href="https://www.fox5ny.com/video/654254?fbclid=IwAR13_vg6rFzBY9LL84rtcTAG-t0lgbEDRweJBOjJnzVS92RbdC2-DTt3JbY"> Fox 5 </a>to talk about the process of making and running Making Authentic Friendships.',
        },
        {
          header: 'Hoda & Jenna',
          imgUrl: require('../assets/HodaJennaImg.png'),
          text: 'Juliana was interviewed by NBC News. Watch her and her brother talk about MAF and how users are staying connected even during COVID-19 <a href="https://www.today.com/video/website-helps-young-adults-with-autism-create-friendships-93007941756?fbclid=IwAR1SXeh-65C_subCF2dFccwrPyNr7y2UYyIkmuTBQCe2J5icKVy-rV4MblY" target="_blank">here</a>!'
        },
        {
          header: 'Women Entrepreneurs',
          logo: require('../assets/entremaglogo.jpg'),
          text: 'Juliana is on the <a href="https://www.entrepreneur.com/article/356893" target="_blank">Top 100 Powerful Women list in 2020</a> by Entrepreneur Magazine!'
        }
      ],
      
      currentNumber: 0,
      showModal: false,
    }
  },

  methods: {
    next: function() {
      if (this.currentNumber !== this.slides.length-1) {
        this.currentNumber += 1;
      } else {
        this.currentNumber = 0;
      }
    },
    prev: function() {
      if (this.currentNumber !== 0) {
        this.currentNumber -= 1;
      } else {
        this.currentNumber = this.slides.length-1;
      }
    },
    openModal: function() {
      this.showModal = true;
    },
    closeModal:function() {
      this.showModal = false;
    }
  },
}
</script>

<style scoped>

/* The Modal (background) */
.modal {
  position: fixed;
  z-index: 1;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: black;
}

/* Modal Content */
.modal-content {
  position: relative;
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  width: 90%;
  max-width: 1200px;
  height:50%;
}

/* The Close Button */
.close {
  color: white;
  position: absolute;
  top: 10px;
  right: 25px;
  font-size: 35px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #999;
  text-decoration: none;
  cursor: pointer;
}

/* Hide the slides by default */
.mySlides {
  height:100%;
  background:black;
}
.mySlides p{
  color:white;
}
/* Caption text */
.caption-container {
  text-align: center;
  background-color: black;
  padding: 2px 16px;
  color: white;
}
.logoVidFlex{
  display:flex;
  flex-direction: column;
  align-items: center;
}
.videoLogo{
  width:331px;
  align-self: center;
  margin-bottom:1.5em;
}
#videoslideTitle{
  font-family: 'chunk';
  font-weight:inherit;
  font-size: 42px;
  color:#F06377;
  align-self: center;
  align-content: center;
  width: 70%;
  margin: auto;
  margin-top: 2rem;
}
.videoslides, .imgslides, .text-block {
  width:700px;
}
.imgslides {
  /* display: flex;
  align-items: center;
  justify-content: center; */
  max-height: 300px;
}
.imgslides img {
  height: 100%;
  max-height: 300px;
}
.leftArrow{
background:none;
outline:none;
border:none;
cursor: pointer;
margin-right:10%;
}
.rightArrow{
background:none;
outline:none;
border:none;
cursor:pointer;
margin-left:10%;

}
.videoSlider{
  display: flex;
  flex-direction: column;
  height: 625px;
  justify-content: center;
}
.slider{
  display:flex;
  flex-direction:row;
  justify-content: center;
  width:70%;
  margin-left:15%;
}
.text-block {
  font-size: 22px;
}
@media screen and (max-width:767px) {
  .lightBoxText{
    font-size:10px;
    margin-top:-85px;
  }
  #videoslideTitle{
  font-size: 16px;
  width:80%;
    margin-left:10%;
}

h2 {
  margin-bottom: 0;
}
  .videoslides, .imgslides, .text-block {
    width: 80vw;
  }

  .imgslides img {
    max-width: 80vw;
  }

  .text-block {
    width: 70vw;
    padding: 0 5vw;
    font-size: 18px;
  }
  .videoLogo{
  width:150px;
  margin-bottom:.5em;
  }
  .video{
    width:100%;
  }
  .leftArrow{
    margin:0;
  }
  .rightArrow{
    margin:0;
  }
  .leftArrow img{
        height:50px !important;
        margin-right:0px;
        margin-top:20px;
    }
  .rightArrow img{
        height:50px !important;
        margin-left:0px;
        margin-top:20px;
    }
}

@media screen and (min-width:768px) and (max-width:1024px) {
  .videoslides, .text-block{
    width:600px;
  }

  .imgslides img {
    max-width: 80vw;
  }
    .leftArrow img{
        height:70px !important;
        margin-right:0px;
    }
  .leftArrow{
      margin:0;
    }
  .rightArrow{
    margin:0;
  }
  .rightArrow img{
        height:70px !important;
        margin-left:0px;
    }
}
@media screen and (max-width:1023px) and (orientation:portrait) {
  .video{
    width:100%;
  }
}
@media screen and (max-width:767px) and (orientation:landscape) {
  .videoslides, .imgslides, .text-block {
    width:355px;
  }

  .imgslides img {
    max-width: 80vw;
  }
  .modal{
    padding-top:10%;
  }
  .video{
    width:60%;
    
  }
  .rightArrow img{
        height:70px !important;
        margin-left:0px;
    }
    .leftArrow img{
        height:70px !important;
        margin-right:0px;
    }
    
}
</style>